module.exports = __webpack_public_path__ + "assets/img/icon6.bd7ff6ec.png";